/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Feature_Free_CreditsInputs */

const en_landing_pricing_feature_free_credits = /** @type {(inputs: Landing_Pricing_Feature_Free_CreditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 AI autofill runs on signup`)
};

const zh_landing_pricing_feature_free_credits = /** @type {(inputs: Landing_Pricing_Feature_Free_CreditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`注册送 5 次 AI 自动填充`)
};

/**
* | output |
* | --- |
* | "5 AI autofill runs on signup" |
*
* @param {Landing_Pricing_Feature_Free_CreditsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_feature_free_credits = /** @type {((inputs?: Landing_Pricing_Feature_Free_CreditsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Feature_Free_CreditsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_feature_free_credits(inputs)
	return zh_landing_pricing_feature_free_credits(inputs)
});
export { landing_pricing_feature_free_credits as "landing.pricing.feature_free_credits" }